import React, { useContext } from "react";

// Component imports
import ToggleSidebar from "./ToggleSidebar";

// Modules imports
import WcsIcon from "../../modules/wcs/Icon";
import QueryIcon from "../../modules/query/Icon";
// import SchemaIcon from "../../modules/schema/Icon";
import HomeIcon from "./HomeIcon";

// Material UI stuff
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";

import clsx from "clsx";

// Global state
import { StateContext } from "../../AppStateContext";
const Sidebar = ({ classes }) => {
  // Consuming global state
  const state = useContext(StateContext);

  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: state.isSidebarOpen,
        [classes.drawerClose]: !state.isSidebarOpen,
        [classes.drawerDark]: state.theme === "dark",
        [classes.drawerLight]: state.theme === "light",
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: state.isSidebarOpen,
          [classes.drawerClose]: !state.isSidebarOpen,
          [classes.drawerDark]: state.theme === "dark",
          [classes.drawerLight]: state.theme === "light",
        }),
      }}
    >
      <ToggleSidebar classes={classes} />

      <Divider />
      <List>
        {state.clientId !== "wcs" ? <HomeIcon moduleName="home" /> : null}

        <WcsIcon moduleName="wcs" />
        <QueryIcon moduleName="query" />
      </List>
    </Drawer>
  );
};

export default Sidebar;
